<template>
  <div class="changelog-container">
    <h2>Change Log</h2>
    <el-card>
      <div>Contenido de la vista Change Log</div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'BotChangeLog'
}
</script>

<style lang="scss" scoped>
.changelog-container {
  padding: 20px;
}
</style> 